import DefaultTooltip from "../ui/tooltips/DefaultTooltip";
import styles from "./TooltipIconComment.module.scss";

const _text = [
  "Comments provide a way of describing the function of the element.",
  "They are not used in the generation process.",
];

function TooltipIconComment({ handle, isHidden }) {
  if (isHidden) {
    return null;
  }

  return (
    <DefaultTooltip handle={handle}>
      <>
        {_text.map((e, index) => (
          <div key={index} className={styles["tooltip__line"]}>
            {e}
          </div>
        ))}
      </>
    </DefaultTooltip>
  );
}

export default TooltipIconComment;
